<template>
  <!--  <el-dialog title="新增 / 編輯车型" :visible.sync="addModelFormVisible" :modal-append-to-body='false'>-->
  <EditFormDialog
    :formData="addModelForm"
    :formVisible="formVisible"
    :formType="'add'"
    :loading="addModelFormVisible"
    @submitForm="addModelSubmit"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form :rules="editFormRules" :model="addModelForm" ref="addModelForm" size="mini" class="edit_form">
      <el-form-item label="品牌" :label-width="formLabelWidth" prop="brand">
        <!--        &lt;!&ndash;            <el-input placeholder="品牌" v-model="addModelForm.brand" clearable></el-input>&ndash;&gt;-->
        <el-select placeholder="品牌" v-model="addModelForm.brandId">
          <el-option v-for="item in listForSelectQuery" :key="item.id"
                     v-bind:label="item.brand" v-bind:value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="型号" :label-width="formLabelWidth" prop="model">
        <el-input placeholder="型号" v-model="addModelForm.model" autocomplete="off"></el-input>

      </el-form-item>
      <el-form-item label="类型" :label-width="formLabelWidth" prop="dynamicType">
        <el-select v-model="addModelForm.dynamicType" placeholder="车类型">
          <el-option label="纯电动" value="0"></el-option>
          <el-option label="混合动力" value="1"></el-option>
          <!--          <el-option v-for="item in listFordynamicType" :key="item.id"-->
          <!--                     v-bind:label="item.dynamicType" v-bind:value="item.id"></el-option>-->
        </el-select>
      </el-form-item>
      <el-form-item label="充电效率" :label-width="formLabelWidth" prop="chargingEfficiency">
        <el-input v-model="addModelForm.chargingEfficiency" autocomplete="off" placeholder="充电效率  单位:kW"></el-input>
      </el-form-item>
      <el-form-item label="续航" :label-width="formLabelWidth" prop="rangeOfVoyage">
        <el-input v-model="addModelForm.rangeOfVoyage" autocomplete="off" placeholder="续航  单位:km"></el-input>
      </el-form-item>
      <el-form-item label="最高时速" :label-width="formLabelWidth" prop="topSpeed">
        <el-input v-model="addModelForm.topSpeed" autocomplete="off" placeholder="最高时速  单位:km/h"></el-input>
      </el-form-item>
      <el-form-item label="车型结构" :label-width="formLabelWidth" prop="structure">
        <el-select v-model="addModelForm.structure" placeholder="车型结构">
          <el-option label="轿车" value="0"></el-option>
          <el-option label="跑车" value="1"></el-option>
          <el-option label="面包车" value="2"></el-option>
          <el-option label="货车" value="3"></el-option>
          <el-option label="皮卡" value="4"></el-option>
          <el-option label="其它" value="5"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
<!--    <div slot="footer" class="dialog-footer">-->
<!--      <el-button size="small" @click="addModelFormVisible = false">取 消</el-button>-->
<!--      <el-button size="small" type="primary" @click.native="addModelSubmit" :loading="addModelSubmitLoading">确 定-->
<!--      </el-button>-->
<!--    </div>-->
  </EditFormDialog>
</template>

<script>
  import Pagination from "../../../../../components/Pagination";
  import carApi from "../../../api/carApi";
  import EditFormDialog from '@/components/EditFormDialog'
  import commonApi from "../../../api/commonApi";
  import {isDecimalThanZero, isInteger, validateInput, validatePhone} from '../../../../../common/validator'

  export default {
    props: {
      formVisible: {
        type: Boolean,
        required: true
      }
    },
    name: "add",
    data() {
      return {
          editFormRules: {
              brandId: [{required: true, message: '请选择品牌', trigger: 'blur'}],
              model: [
                  {required: true, message: '请输入车型', trigger: 'blur'},{
                      validator: function (rule, value, callback) {
                          validateInput(rule, value, callback, 0, 10, true, true, true, false, false, true, false)
                      }, required: true,trigger: 'blur'
                  }],
              dynamicType: [{required: true, message: '请选择类型', trigger: 'blur'}],

              carTypeId: [{required: true, message: '请选择车型', trigger: 'blur'}],
              chargingEfficiency: [
                  {required: true, message: '请输入充电效率', trigger: 'blur'},{
                      validator: function (rule, value, callback) {
                          validateInput(rule, value, callback, 0, 5, true, true, true, false, false, false, true)
                      },required: true, trigger: 'blur'
                  }],
              rangeOfVoyage: [
                  {required: true, message: '请输入里程', trigger: 'blur'},{
                      validator: function (rule, value, callback) {
                          validateInput(rule, value, callback, 0, 5, true, true, true, false, false, false, true)
                      }, required: true,trigger: 'blur'
                  }],
              topSpeed: [
                  {required: true, message: '请输入最大速度', trigger: 'blur'},{validator: function (rule, value, callback) {
                          validateInput(rule, value, callback,0,5,true,true,true,false,false,false,true)
                      },required: true,trigger: 'blur'}],
              structure: [{required: true, message: '请选择结构', trigger: 'blur'}],
          },

        views: {},
        enumData: [{
          carTypeData: ''
        }],
        inputVisible: false,
        inputValue: '',
        // restaurants: [],
        tableData: [{}],
        modelTableData: [{}],
        brandTableData: [{}],
        carSearchForm: {},
        modelSearchForm: {},
        brandSearchForm: {},
        listForSelectQuery: {},
        operatorForSelect: '',
        listForSelect: {},
        getCarsLoading: false,
        getBrandLoading: false,
        getModelsLoading: false,
        addForm: {},
        editForm: {},
        carsLoading: false,
        addModelForm: {},
        addBrandForm: {},
        editTypeForm: {},
        addSubmitLoading: false,
        editSubmitLoading: false,
        carModelLoading: false,
        addModelSubmitLoading: false,
        addBrandSubmitLoading: false,
        carBrandLoading: false,
        innerForm: {},
        searchTabsAddForm: {},
        addFormVisible: false,
        editFormVisible: false, // 外部对话框
        addModelFormVisible: false,
        addBrandFormVisible: false,
        viewVisible: false, // 视图
        multipleSelection: [],
        activeName: 'carList',
        innerFormName: 'coordinate',
        viewName: 'detailForm',
        showFilters: true,
        input: '',
        val_time: '', // 创建时间
        formLabelWidth: '150px',
        // 分页参数
        pageparm: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        activeNames: ['basicInformation', 'addressInformation'],
        activeName: 'carList',

      }
    },
    watch: {
      formVisible: {
        handler: function () {
          this.initCarBrand();
        }
      }
    },
    methods: {
      closeDialog(formType) {
        this.restForm();
        this.$emit("closeDialog", formType)
      },
      restForm() {
        this.addModelForm = {}
      },
      addModelSubmit(addModelForm) {
          this.$refs.addModelForm.validate((valid) => {
              if (!valid) {
                  return;
              } else {
                carApi.checkDuplicateModel(this.addModelForm.model).then((res)=>{
                  if (res.code === 0) {
                    if (res.data.length === 0) {
                      this.addModelSubmitLoading = true
                      let param = JSON.stringify(this.addModelForm)
                      carApi.saveOrUpdateModel(param).then((res) => {
                        this.addModelSubmitLoading = false
                        if (res.code === 0) {
                          this.$message({
                            message: res.message,
                            type: 'success'
                          })
                          this.addModelFormVisible = false
                          this.$emit('afterAdd')
                          // this.submitModelSearchForm()
                        } else {
                          this.$message.error(res.message)
                        }
                      })
                    } else {
                      this.$message.error('车型已添加')
                    }
                  } else {
                    this.$message.error(res.message)
                  }
                })
              }
          })
      },
      // 加载下拉框
      loadSelectItem() {
        let param = Object.assign({}, this.pageparm)
        // brand下拉框
        commonApi.listForSelectQuery(param).then((res) => {

          if (res.code === 0) {
            this.listForSelectQuery = res.data.records
          }
          //  (res.data.records)
        })
        // 运营商下拉框
        commonApi.operatorSelectionList().then((res) => {
          if (res.code === 0) {
            this.operatorForSelect = res.data
          }

        });
        // model下拉框
        commonApi.listForSelect(param).then((res) => {
          if (res.code === 0) {
            this.listForSelect = res.data.records
          }

        })
      },
      initCarBrand(){
        let param = Object.assign({}, this.pageparm);
        commonApi.listForSelectQuery(param).then((res) => {
          if (res.code === 0) {
            this.listForSelectQuery = res.data.records
          }
        })
      }

    },
    components: {
      Pagination,
      EditFormDialog
    },
    created: function () {
      this.loadSelectItem()
    },
    mounted: function () {


    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/model/add.vue